import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { CepResponse } from '@/types'
import axios from 'axios'
import { env, envUrlByService } from '@/env'

type UseReadZipcodeProps = Omit<
  UseQueryOptions<CepResponse>,
  'queryKey' | 'queryFn'
>

export async function readZipcode(zipcode: string) {
  const response = await axios.get<CepResponse>(
    `${envUrlByService['accounting-dealer'][env.MODE === 'test' ? 'development' : env.MODE]}/v3/person/zipcode`,
    { params: { zipcode } },
  )

  return response.data
}

export function useReadZipcode(zipcode: string, options?: UseReadZipcodeProps) {
  return useQuery({
    queryKey: ['zipcode', zipcode],
    queryFn: () => readZipcode(zipcode),
    ...options,
  })
}
